import React from 'react';

import { FormHandler, Input, Label } from "Components/Form";
import {Alert} from 'Components/Partials';
import TitleText from "Components/Utilities/TitleText";
import { PrimaryButton, SecondaryButton } from "Components/Button";
import TransparentButton from "Components/Button/TransparentButton";
import WhiteButton from "Components/Button/WhiteButtton";

import ScoresApi from 'Services/Api/Site/Scores';

class End extends React.Component {
    /**
     * @var state
     */
    state = {
        submitted: false
    };

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const {score} = this.props;

        form.game_id = 'pacman_3';
        form.score = score;

        return ScoresApi.post(null, form);
    };

    /**
     * @method handleSuccess
     */
    handleSuccess = () => {
        this.props.setParentState({
            stage: 'leaderboard'
        });
    }

    /**
     * @method render
     * @return {*}
     */
    render () {
        const {submitted} = this.state;
        const {score, gameCompleted, working, alert, handleSubmit} = this.props;

        return (
            <div className="h-full overflow-y-auto">
                <TitleText 
                    subtitle="Well Played!" 
                    title={gameCompleted ? 'Mission Complete' : 'Game Over'}
                />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-6 mt-6 lg:mt-10 xl:mt-16">
                    <div className={`
                        text-app-turquoise rounded-full bg-app-yellow mx-auto font-mono 
                        flex flex-col justify-center items-center text-center 
                        h-[160px] w-[160px] lg:h-[250px] lg:w-[250px]
                    `}>
                        <div className="uppercase rubrik-light text-sm lg:text-md">
                            You Scored
                        </div>

                        <div className="uppercase nobblee-bold font-bolder text-6xl lg:text-9xl">
                            {score}
                        </div>

                        <div className="uppercase nobblee-bold text-bold text-md lg:text-2xl">
                            Points
                        </div>
                    </div>

                    {submitted &&
                        <div className={`
                            text-app-yellow retro-gaming uppercase text-lg font-think w-full 
                            flex justify-center lg:justify-start items-center text-center lg:text-left
                        `}>
                            Saved successfully!
                        </div>
                    }
                           
                    {!submitted && 
                        <form onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.handleSuccess)}>
                            <p className="text-app-yellow retro-gaming uppercase text-lg text-center lg:text-left font-think w-full mb-5">
                                Submit Identity
                            </p>

                            {alert !== null && (<Alert {...alert} />)}

                            {this.renderInput('nickname', 'Nickname')}
                            {this.renderInput('employee_number', 'Employee No')}

                            <div className="flex flex-col md:flex-row justify-center items-center lg:justify-start gap-5 my-5">
                                <WhiteButton 
                                    text="Save Score"
                                    working={working}
                                />

                                <div
                                    className="text-white cursor-pointer"
                                    onClick={this.handleSuccess}
                                > 
                                    Don't Save Score
                                </div>
                            </div>
                        </form>
                    }
                </div>
            </div>
        );
    }

    /**
     * @method renderInput
     * @param {string} key
     * @param {string} label
     * @return {*}
     */
    renderInput(key, label) {
        const {form, handleInput} = this.props;

        return (
            <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-2 mb-4">
                <div>
                    <Label 
                        htmlFor={key} 
                        className="text-sm xl:text-base my-auto"
                        textColor="text-white"
                        label={label}
                    />
                </div>

                <div className="col-span-2">
                    <Input
                        containerClassName="mt-0 w-full text-xs"
                        id={key}
                        value={form ? form[key] : null}
                        onChange={v => handleInput(key, v)}
                    />
                </div>
            </div>
        );
    }
}

export default FormHandler(End);